import AbstractService from "@/services/abstract.service"
import AssetsTransformer from "@/transformers/assets.transformer.js"

class AssetsService extends AbstractService {
  constructor() {
    super({ baseUri: "/api/assets" })
  }

  upload(file, type = 1, extra = {}) {
    return this.post(`${this.baseUri}/upload`, {
      contentType: "multipart",
      transformer: AssetsTransformer,
      needsAuth: true,
      payload: {
        file,
        type,
        extra: JSON.stringify(extra)
      }
    })
  }
}
const assetsService = new AssetsService()
export default assetsService
